export default (params) => ({
  trigger: {
    name: 'order_block.select_charger_icon',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: null,
      },
    },
    nonInt: false,
  },
});
